/* eslint-disable no-unused-vars */

export enum TimeSpanType {
  LAST_30_DAYS = 1,
  LAST_7_DAYS = 2,
  LAST_1_DAY = 3,
}
